/**
 * サニタイズ(エンコード)処理を行う
 * @param {*} str 
 */
exports.encode = function (str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
};

/**
 * サニタイズ(デコード)処理を行う
 * @param {*} str 
 */
exports.decode = function (str) {
    return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'').replace(/&amp;/g, '&');
};